<script>
	export let data = {};
</script>

<div class="UICoverTitle">
	<div class="UICoverTitle-img" style="background-image:url({data.image})" />
	<div class="UICoverTitle-box">
		<h3 class="UICoverTitle-title">{@html data.text}</h3>
	</div>
</div>

<style global>
	.UICoverTitle {
		height: 240px;
		position: relative;
		margin: 3em 0;
	}
	:global(.pc) .UICoverTitle {
		height: 320px;
	}
	.UICoverTitle-img {
		position: absolute;
		z-index: 1;
		width: 100%;
		height: 100%;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: 50%;
		filter: brightness(70%);
	}

	.UICoverTitle-box {
		position: absolute;
		text-align: center;
		z-index: 2;
		width: 100%;
		top: 50%;
		transform: translateY(-50%);
	}

	.UICoverTitle-title {
		padding: 1em;
		max-width: 1000px;
		margin: 0 auto;
		font-size: 2em;
		text-align: center;
		color: #fff;
		font-weight: bold;
		text-shadow: 0 0 16px rgb(0 0 0 / 50%);
		letter-spacing: 0.05em;
	}

	:global(.pc) .UICoverTitle-title {
		font-size: 2.4em;
	}
</style>
